var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showMask && _vm.show,
            expression: "showMask && show",
          },
        ],
        staticClass: "pop-mask",
        class: _vm.popMaskClass,
        on: { click: _vm.clickMask },
      }),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: _vm.animation, css: _vm.enableAnimation },
          on: {
            "after-leave": _vm.afterLeaveCb,
            "after-enter": function ($event) {
              return _vm.$emit("after-enter")
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show || _vm.visibilityMode,
                  expression: "show || visibilityMode",
                },
              ],
              staticClass: "pop hidden-scrollbar",
              class: [_vm.animation, _vm.customClass],
              style: _vm.visibilityMode
                ? { visibility: _vm.show ? "visible" : "collapse" }
                : {},
            },
            [
              _vm._t("default"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.allowClose,
                    expression: "allowClose",
                  },
                ],
                staticClass: "iconfont",
                class: [_vm.closeIcon, _vm.closeClass],
                on: { click: _vm.close },
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }